import React from "react";

export interface MobileEmptyIconProps {
  id?: string;
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  onClick?: () => void;
}

export const MobileIconEmpty = ({ id, width, height, style, onClick, ...rest }: MobileEmptyIconProps) => {
  return (
    <span id={id} style={style} onClick={onClick} {...rest}>
      <svg height={height} viewBox="0 0 10 20" width={width}>
        <g fill="none" stroke="#000" strokeWidth="1.25">
          <rect height="18.75" rx="2.5" width="8.75" x=".625" y=".625" />
          <g strokeLinecap="square">
            <path d="m3.125 16.875h3.75" />
            <path d="m4.5 2.875h1" />
          </g>
        </g>
      </svg>
    </span>
  );
};
